import { render } from "./ReturnsPolicy.vue?vue&type=template&id=305db90d"
import script from "./ReturnsPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnsPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__